import React from 'react';



export default function LogoHeader() {

    let today = new Date();
    let periodo = (today.getMonth() + 1) + '' + today.getDate();

    if (periodo >= 1208) {

        return (
            <img style={{ paddingTop: '7px' }} height="75" alt="RED CAFIRA" src="https://cafira.sfo2.digitaloceanspaces.com/red-cafira/logo.jpg" />
        )

    } else {

        return (
            <img style={{ paddingTop: '7px' }} height="75" alt="RED CAFIRA" src="https://cafira.sfo2.digitaloceanspaces.com/red-cafira/logo.jpg" />
        )

    }


}